    import React from "react";

interface AuthMiddlewareProps {
  element: React.FC;
}

const AuthMiddleware: React.FC<AuthMiddlewareProps> = ({
  element: Element,
}) => {
  const handleLoginNavigate = (Element: React.FC) => {
    sessionStorage.clear();
    return <Element />;
  };

  return handleLoginNavigate(Element);
};

export default AuthMiddleware;
